import { useMemo } from 'react';
import styles from './survey-answers.module.css'
import ReactEcharts from "echarts-for-react";

const NumericAnswers = (props) => {
    const { t, question } = props;
    const { name, order, data } = question;
    const { data: graphData, stats } = data;

    const option = useMemo(() => {
        if (!data || !graphData || !graphData.length) return;

        const option = {
            grid: { right: 10, top: 10 },
            xAxis: { type: 'value' },
            yAxis: { type: 'value' },
            dataset: { source: graphData },
            series: [
                {
                    name: 'Total answers',
                    type: 'line',
                    areaStyle: {},
                    encode: {
                        x: 'numberValue',
                        y: 'count'
                    }
                }
            ],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    animation: false
                }
            },
            dataZoom: [
                {
                    type: 'inside',
                    orient: 'horizontal',
                    start: 0,
                    end: 100,
                    minSpan: 10,
                },
                {
                    type: 'slider',
                    show: true,
                }
            ],
        };
        return option;
    }, [graphData])

    return (
        <>
            <p className={styles['question-title']}>{order}. {name}</p>
            <div className={styles['numeric-stats']}>
                <p><strong>{t("average")}</strong>: {stats.average?.toFixed(2) || "N/D"}</p>
                <p><strong>{t("median")}</strong>: {stats.median || "N/D"}</p>
                <p><strong>{t("range")}</strong>: {stats.min && stats.max ? `${stats.min} - ${stats.max}` : "N/D"}</p>
            </div>
            {
                option
                    ? <ReactEcharts option={option} />
                    : <p>N/D</p>
            }
        </>
    )
}

export default NumericAnswers